import { connect } from "react-redux";
import { RootState } from "../state/reducers";
import { DisabledState } from "../state/reducers/disabledReducer";
import { HiddenState } from "../state/reducers/hiddenReducer";
import { ID, Layout, SectionType } from "../types";
import Part from "./Part";

interface PartListProps {
  parts: ID[];
  sectionType: SectionType;
  layout: Layout;
  disabled: DisabledState;
  hidden: HiddenState;
}

const PartList: React.FC<PartListProps> = ({
  parts,
  sectionType,
  layout,
  disabled,
  hidden,
}) => {
  return (
    <div className={`part-list layout-${layout}`}>
      {parts.map((id) => (
        <Part key={id} partId={id} sectionType={sectionType} layout={layout} />
      ))}
    </div>
  );
};

interface ConnectProps {
  parts: ID[];
  sectionType: SectionType;
  layout: Layout;
}
export default connect((state: RootState, props: ConnectProps) => {
  const { parts, sectionType, layout } = props;
  return {
    parts,
    sectionType,
    layout,
    disabled: state.disabled,
    hidden: state.hidden,
  };
}, {})(PartList);
